import { Cog, Shield } from "lucide-react";
import { cn } from "@/lib/utils";

export function ShieldCogIcon({ className }: { className?: string }) {
  return (
    <span className={cn("relative inline-flex shrink-0 items-center justify-center", className)}>
      <Shield className="size-full" />
      <Cog className="absolute inset-0 m-auto size-[0.5em]" strokeWidth={2.2} />
    </span>
  );
}
